import { useContext } from 'react';

import { AuthContext } from '../context';

export const useSignedIn = () => {
  const { state } = useContext(AuthContext);

  return !!state?.token;
};
